import { EnviromentZone, HowdenLoginBehaviour, HowdenLoginKind, IHowdenEnvironment, LogLevel, TENANT_TYPES, Theme } from '@howdeniberia/core-front';

export const environment = {
  zone: EnviromentZone.DEVELOPMENT,
  appIdSecurity: 12, //Es necesario establecer el Id de la aplicación asignado en Howden Security
  loginBehaviour: HowdenLoginBehaviour.REDIRECT,
  loginKind: HowdenLoginKind.EXTERNAL,
  howdenLoginUrl: 'https://how-loginb2c.app-dev.howdeniberia.com',
  externalAppTitle: 'Mapa de Riesgos',
  fixedTenant: TENANT_TYPES.artai, //Al fijar el tenant ya no se muestra la empresa del usuario
  fixedTheme: Theme.LIGHT,
  logLevel: LogLevel.VERBOSE,
  logoDestination: ''
} as IHowdenEnvironment;
